import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { selectStudent } from '../../store/slices/studentSlice';
import { useMediaQuery, useTheme } from '@mui/material';
import './style.css';

interface StudentIdCardProps {
  photo?: string;
  school?: string;
  year?: string;
  studentId?: string;
  studentName?: string;
  studentClass?: string;
  phoneNumber?: string;
  principal?: string;
  signature?: string;
}

const StudentIdCard: React.FC<StudentIdCardProps> = ({
  photo,
  school = 'Unknown School',
  year = '2026-27',
  studentId = 'N/A',
  studentName = 'Unknown Student',
  studentClass = 'N/A',
  phoneNumber = 'N/A',
  principal = 'President',
  signature = 'Authorized Signature',
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleClick = () => {
    // Use the full class prefix for grade (e.g., 'Class-04 Red' -> 'Class-04')
    const gradeMatch = (studentClass || '').match(/(Class-[0-9]+)/i);
    const grade = gradeMatch ? gradeMatch[1] : 'Class-00';

    // selectStudent will automatically detect mobile classroom mode
    dispatch(selectStudent({
      id: studentId || 'unknown-id',
      name: studentName || 'Unknown Student',
      class: studentClass || 'Unknown Class',
      school: school || 'Unknown School',
      photo: photo || '',
      phoneNumber: phoneNumber || '',
      grade: grade, // Add the extracted grade
    }));

    navigate('/dashboard');
  };

  // Mobile compact layout
  if (isMobile) {
    return (
      <div className="idcard-container-mobile" onClick={handleClick} style={{ cursor: 'pointer' }}>
        <div className="idcard-header-mobile">
          <div className="idcard-school-mobile">{school}</div>
          <div className="idcard-year-mobile">LiveOlympiad {year}</div>
        </div>
        <div className="idcard-main-mobile">
          <div className="student-info-mobile">
            <div className="student-name-mobile">{studentName}</div>
            <div className="student-class-mobile">{studentClass}</div>
            <div className="student-contact-mobile">{phoneNumber}</div>
          </div>
        </div>
      </div>
    );
  }

  // Desktop full layout
  return (
    <div className="idcard-container" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <div className="idcard-header">
        <div className="idcard-logo">
          <div className="idcard-school">{school}</div>
        </div>
      </div>
      <div className="idcard-subheader">
        <span className="idcard-title">LiveOlympiad {year}</span>
      </div>
      <div className="idcard-main">
        <div className="idcard-content-row">
          <div className="idcard-photo">
            <img src={photo} alt="Student" className="student-photo" />
          </div>
          <div className="idcard-details">
            <div className="idcard-details-table">
              <div>Student Contact</div>
              <div>{phoneNumber}</div>
              <div>Student Name</div>
              <div>{studentName}</div>
              <div>Class</div>
              <div>{studentClass}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="idcard-footer">
        <span className="idcard-signature">{signature}</span>
        <span className="idcard-principal">{principal}</span>
      </div>
    </div>
  );
};

export default StudentIdCard;